<script>
export default {
  inject: ['gsap'],
  name: "TitleBannersHome",
  methods:{
    scrollToForm(){
      if (window.innerWidth <= 700){
        $([document.documentElement, document.body]).animate({
          scrollTop: $("#lead-form").offset().top -10
        }, 0);
      }
      else{
        $([document.documentElement, document.body]).animate({
          scrollTop: $("#lead-form").offset().top -30
        }, 0);
      }
    }
  },
  mounted(){
    var element = $(".new-places-home")
    this.gsap.to('.new-places-home', {
      duration: 4,
      scrollTrigger: {
        trigger: element, // Элемент, который будет триггером
        start: "top center", // Когда триггер сработает (например, когда верх элемента достигнет центра экрана)
        toggleClass: "active",
        once:true
      }
    });
  }
}
</script>

<template>
  <div class="new-places-home left">
    <span class="sms-cloud-block mobile-nv" style="--sms-color-block:#FF9166">
      <svg width="604" height="370" viewBox="0 0 604 370" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask id="path-1-inside-1_769_681" fill="white">
          <path d="M59.9996 0C26.8625 0 -0.000427246 26.8629 -0.000427246 60V310C-0.000427246 343.137 26.8625 370 59.9996 370H600.295C603.249 370 604.737 365.751 602.796 363.524C595.551 355.211 590.942 343.252 590.758 329.92L590.753 329.092V60C590.753 26.8631 563.89 0.000252406 530.753 0H59.9996Z"/>
        </mask>
        <path d="M59.9996 0C26.8625 0 -0.000427246 26.8629 -0.000427246 60V310C-0.000427246 343.137 26.8625 370 59.9996 370H600.295C603.249 370 604.737 365.751 602.796 363.524C595.551 355.211 590.942 343.252 590.758 329.92L590.753 329.092V60C590.753 26.8631 563.89 0.000252406 530.753 0H59.9996Z" fill="white"/>
        <path d="M-0.000427246 310H-8.00043H-0.000427246ZM590.758 329.92L582.759 330.03L582.759 329.999L582.758 329.967L590.758 329.92ZM590.753 329.092L582.754 329.139L582.753 329.115V329.092H590.753ZM590.753 60H598.753H590.753ZM530.753 0V-8H530.754L530.753 0ZM602.796 363.524L608.827 358.268L602.796 363.524ZM59.9996 0V8C31.2808 8 7.99957 31.2812 7.99957 60H-0.000427246H-8.00043C-8.00043 22.4446 22.4442 -8 59.9996 -8V0ZM-0.000427246 60H7.99957V310H-0.000427246H-8.00043V60H-0.000427246ZM-0.000427246 310H7.99957C7.99957 338.719 31.2808 362 59.9996 362V370V378C22.4442 378 -8.00043 347.555 -8.00043 310H-0.000427246ZM59.9996 370V362H600.295V370V378H59.9996V370ZM602.796 363.524L596.765 368.78C588.166 358.913 582.967 345.082 582.759 330.03L590.758 329.92L598.758 329.81C598.918 341.422 602.937 351.509 608.827 358.268L602.796 363.524ZM590.758 329.92L582.758 329.967L582.754 329.139L590.753 329.092L598.753 329.045L598.758 329.873L590.758 329.92ZM590.753 329.092H582.753V60H590.753H598.753V329.092H590.753ZM590.753 60H582.753C582.753 31.2814 559.472 8.00022 530.753 8L530.753 0L530.754 -8C568.309 -7.99971 598.753 22.4447 598.753 60H590.753ZM530.753 0V8H59.9996V0V-8H530.753V0ZM600.295 370V362C597.418 362 596.152 364.085 595.883 364.809C595.624 365.504 595.357 367.164 596.765 368.78L602.796 363.524L608.827 358.268C612.176 362.11 612.135 367.008 610.879 370.385C609.613 373.79 606.127 378 600.295 378V370Z" fill="#FF9166" mask="url(#path-1-inside-1_769_681)"/>
      </svg>

      <span class="sms-cloud-block-content left">
        <span class="sms-cloud-block-content-txt left">
          Наша компания возьмет на себя весь<br>
          спектр задач по подготовке и сдаче<br>
          Вашей квартиры в аренду.<br>
          <br>
          Обеспечим стабильный доход и 100%<br>
          гарантию сохранности квартиры на весь <br>
          срок договора.
        </span>
        <span class="btn-num black flex flex-xy-center left" @click.prevent="scrollToForm()">
          Заказать звонок
        </span>
      </span>
    </span>
    <span class="sms-cloud-block mobile" style="--sms-color-block:#FF9166">


      <span class="sms-cloud-block-content left">
        <span class="sms-cloud-block-content-txt left">
          Наша компания обеспечит<br> высокий доход и безопасность <br> ваших инвестиций.<br>
          <br>
          Защитит права собственников <br> и арендаторов, а также<br> обеспечит комплексную <br>подготовку и управление<br> арендными объектами.
        </span>
        <span class="btn-num black flex flex-xy-center left" @click.prevent="scrollToForm()">
          Заказать звонок
        </span>
      </span>
    </span>
    <span class="home-title-text-block flex flex-x-center">
      <span class="home-title-text">Индивидуальный Подход <br>В Преображении Интерьера</span>
    </span>
    <span class="new-places-home-content">
      <span class="home-title-text-line"></span>
      <svg width="1316" height="609" viewBox="0 0 1316 609" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1442 12.0103C1282 9.51034 906.799 461.252 1113.5 579.011C1196 626.012 1312.5 579.011 1205.5 453.011C1011.07 224.061 -286 345.511 128.5 579.011M128.5 579.011C116 555.678 99 509.511 107 488.511M128.5 579.011C97.3335 572.344 30 570.511 12 579.011" stroke="#FFD166" stroke-width="24" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <img class="home-img-1" src="/assets/home-1.png" alt="">
      <img class="home-img-3" src="/assets/home-3.png" alt="">
      <svg class="title-banners-home-yellow-line" width="390" height="154" viewBox="0 0 390 154" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M411.499 8.0008C377.769 -0.102983 238.857 -2.8311 198.999 81.5013C117 255 -6.33848 46.2635 -23.0002 14.4992" stroke="#FFE866" stroke-width="7" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>

      <span class="home-img-left flex flex-column">
        <img src="/assets/home-2-1.png" alt="">
        <img src="/assets/home-2-2.png" alt="">
        <img src="/assets/home-2-3.png" alt="">
      </span>

    </span>
  </div>

</template>

<style scoped>

</style>